import { initializeApp, } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { collection, query, where, orderBy, limit, doc, addDoc, deleteDoc, getDoc, onSnapshot} from "firebase/firestore";

import { getAuth, signInAnonymously, signInWithPopup, setPersistence, browserSessionPersistence , EmailAuthProvider, reauthenticateWithCredential, signInWithRedirect, getRedirectResult, signInWithCredential, signInWithEmailAndPassword, GoogleAuthProvider, signOut} from "firebase/auth";

let mockinstancia = undefined;
let mockEleicoes = undefined;
let mockLocalidades = undefined;
let mockCargos = undefined;
let mockZonas = undefined;
let mockLocaisVotacao = undefined;
let mockTotalizacao = undefined;
let mockAcompanhamentoSecoes = undefined;

if(process.env.REACT_APP_MOCK_DATA==true){    
    mockinstancia = require("../assets/json/mockInstancia");
    mockEleicoes = require("../assets/json/mockEleicoes");
    mockLocalidades = require("../assets/json/mockLocalidades");
    mockCargos = require("../assets/json/mockCargos");
    mockZonas = require("../assets/json/mockZonas");
    mockLocaisVotacao = require("../assets/json/mockLocaisVotacao");
    mockTotalizacao = require("../assets/json/mockTotalizacao");
    mockAcompanhamentoSecoes = require("../assets/json/mockAcompanhamentoSecoes");
}

//Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APIID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  
};

//Initialize Firebase  
const app = initializeApp(firebaseConfig);
//Enable analyctitcs
//const analytics = getAnalytics(app);
//Authenticate
const auth = getAuth();

//Token de debug
if (process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN) {
    window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN
}

// init app check
const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_FIREBASE_RECAPTCHA_TOKEN),
    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    isTokenAutoRefreshEnabled: true
});

const db = getFirestore(app);

let totalizacaoUnsubscribe;
let acompanhamentoSecoesUnsubscribe;
let instanciaInfoUnsubscribe;
let eleicoesUnsubscribe;
let localidadesUnsubscribe;
let cargosUnsubscribe;
let zonasEleitoraisUnsubscribe;
let locaisVotacaoUnsubscribe;
let pendentesUnsubscribe;

export const hasAcompanhamentoSecoesSubscribe = () => {
    if(acompanhamentoSecoesUnsubscribe){
        return true;
    }
    return false;
}

export const hasTotalizacaoSubscribe = () => {
    if(totalizacaoUnsubscribe){
        return true;
    }
    return false;
}

export const hasPendentesSubscribe = () => {
    if(pendentesUnsubscribe){
        return true;
    }
    return false;
}

export const hasInstanciaInfoSubscribe = () => {
    if(instanciaInfoUnsubscribe){
        return true;
    }
    return false;
}

export const hasCargosSubscribe = () => {
    if(cargosUnsubscribe){
        return true;
    }
    return false;
}

export const hasLocalidadesSubscribe = () => {
    if(localidadesUnsubscribe){
        return true;
    }
    return false;
}

export const hasLocaisVotacaoSubscribe = () => {
    if(locaisVotacaoUnsubscribe){
        return true;
    }
    return false;
}

export const hasZonasEleitoraisSubscribe = () => {
    if(zonasEleitoraisUnsubscribe){
        return true;
    }
    return false;
}

export const onAuthChange = (setUser) =>{
    auth.onAuthStateChanged(function(user) {
        if (user) {
            setUser(user)
        } else {            
            setUser()
        }
    });
}

export const getUser = () => {       
    //Authenticate  
    return auth.currentUser
}

export const anonimousLogin = ()=>{
    signInAnonymously(auth);
}

export const login = async (email, password, setUser) => {

    return setPersistence(auth, browserSessionPersistence)
    .then(() => {
        return signInWithEmailAndPassword(auth, email, password).then((usrCredencial) => {
            // Signed in
            //const user = usrCredencial.user;

            //setUser(usrCredencial.user)
            return usrCredencial
        }).catch((error) => {              
            throw Error(error.message)      
        });        
    
    }).catch((error) => {
        throw Error(error.message)  
    });
}

export const loginComGooglePopUp = async (setUser) => {
    const provider = new GoogleAuthProvider();
    
    return setPersistence(auth, browserSessionPersistence)
    .then(() => {

        return signInWithPopup(auth, provider)
        .then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const credential = GoogleAuthProvider.credentialFromResult(result);
            //const token = credential.accessToken;
            // The signed-in user info.
            //const user = result.user;
            //setUser(user)
            return credential

        }).catch((error) => {
            throw Error(error.message)           
        });

    }).catch((error) => {
        throw Error(error.message)
    });
}

export const logout = async (setUser) => {
    const provider = new GoogleAuthProvider();

    return await signOut(auth).then(() => {
        // Sign-out successful.
        //setUser()
    }).catch((error) => {
        // An error happened.
    });

}

export const carregaInstancia = async (mock,urlParameter, user) => {
    try{
        if (mock || urlParameter){    
            let instancia = process.env.REACT_APP_FIREBASE_TEST_INSTANCE || process.env.REACT_APP_FIREBASE_DEFAULT_INSTANCE;
            if(urlParameter){
                instancia=urlParameter;
            }
            
            //Verifica se instancia desejada  existe e se está online
            const docSnapInstancia = await getDoc(doc(db, "/instancias/", instancia));
            if (docSnapInstancia.exists()){ 
                if(docSnapInstancia.data().onLine!=false || user){     
                    return await new Promise(async function(resolve, reject) {                
                        resolve(instancia);
                        return(instancia);
                    })                            
                }
            }else{
                throw new Error("Instancia ("+instancia+") Inexistente no firebase");
            }            
        }
    
        //Obtem instancia global do firebase caso não tenha o urlParameter ou caso a instancia desejada no urlParameter esteja offline
        if(!process.env.REACT_APP_FIREBASE_INSTANCIA_REF){
            throw new Error("Configuração de coleção global do Firebase não encontrada");
        }        
        const docSnapGlobal = await getDoc(doc(db, "/configuracoes/", "global"));            
        if (docSnapGlobal.exists()){      
            let instanciaGlobal = docSnapGlobal.data()[process.env.REACT_APP_FIREBASE_INSTANCIA_REF];
           
            //verifica se ainstancia Global está online
            const docSnapInstanciaGlobal = await getDoc(doc(db, "/instancias/", instanciaGlobal));
            if (docSnapInstanciaGlobal.exists()){                 
                if(docSnapInstanciaGlobal.data().onLine!=false || user){     
                    return instanciaGlobal;                          
                }
            }
        }
        //caso a instancia global não esteja online gera erro
        throw new Error("Não foi possível carregar a instancia global");  
        
    }catch(error){
        console.error("CarregaInstanciaPadrao : "+error);
        throw error;
    }
}

export const getInstanciaInfo = async (mock,instancia,setInstanciaInfo,setUfs,setEleicoes,setLocalidades,user) => {
    try{
        if (mock && mockinstancia){        
            return await new Promise(async function(resolve, reject) {
                setInstanciaInfo(mockinstancia);              
                resolve(mockinstancia);                               
            });        
        }

        if(instanciaInfoUnsubscribe){
            instanciaInfoUnsubscribe();
            console.info("getInstanciaInfo: Unsubscribe listner de instancia");
        }

        if(instancia){           
            instanciaInfoUnsubscribe = onSnapshot(doc(db, "instancias", instancia), (doc) => {                
                if(doc.exists()){            
                    let instanciaObj = doc.data()
                    instanciaObj['id']=instancia                                       
                    if(user){
                        instanciaObj['onLine']=true
                    }                    
                    setInstanciaInfo(instanciaObj);
                    //set eleições a partir da informação da instancia
                    setEleicoes(instanciaObj['eleicoes'])
                    //set localidade a partir da informação da instancia
		            //setLocalidades(instanciaObj['localidades'])
                    //set uf a partir da informação da instancia                 
                    setUfs([{...instanciaObj?.uf,...{"isUf":true}}])
                }else{
                    console.error("getInstanciaInfo: instancia não encontrada")                    
                }                
            },(error) => {                
                throw error;
            });            
        }

    }catch(error){
        if(instanciaInfoUnsubscribe){
            instanciaInfoUnsubscribe();
        }
        console.error("getInstanciaInfo: "+error);   
        throw error;
    }    
}

export const getInstanciasAtivas = async (setInstanciasAtivas) => {
    try{        
        //Obtem instancia ativas na configuração global do firebase              
        const docSnap = await getDoc(doc(db, "/configuracoes/", "global"));            
        let instanciasAtivas=[]        
        if (docSnap.exists()){                                   
            docSnap.data()["instanciasAtivas"].forEach(inst => instanciasAtivas.push(inst))  
            setInstanciasAtivas(instanciasAtivas)
            return instanciasAtivas        
        }
        setInstanciasAtivas(instanciasAtivas)
        throw new Error("Não foi possível carregar as instancias da configuração global");  
        
    }catch(error){
        console.error("getInstanciasAtivas : "+error);
        throw error;
    }
}


export const getEleicoes = async (mock,instancia,setEleicoes) => {
    try{
        if (mock && mockEleicoes){        
            return await new Promise(async function(resolve, reject) {
                setEleicoes(mockEleicoes);              
                resolve(mockEleicoes);                               
            });        
        }
        
        if(eleicoesUnsubscribe){
            eleicoesUnsubscribe();
            console.info("getEleicoes: Unsubscribe listner de eleicoes");
        }

        if(instancia){      
            const queryEleicoes = query(collection(db, "/instancias/"+instancia+"/eleicoes"));                                    
            eleicoesUnsubscribe = onSnapshot(queryEleicoes, (querySnapshot) => {
                if(!querySnapshot.empty){                    
                    const list = [];
                    querySnapshot.forEach((doc) => {                
                        list.push(doc.data());
                    });                            
                    setEleicoes(list);
                }else{
                    console.error("getEleicoes: nenhuma eleição encontrada")                
                }

            },(error) => {
                throw error;
            });            
        }

    }catch(error){
        if(eleicoesUnsubscribe){
            eleicoesUnsubscribe();
        }
        console.error("getEleicoes: "+error);
        throw error;       
    }
}

export const getLocalidades = async (mock,instancia,setLocalidades) => {
    try{
        if (mock && mockLocalidades){        
            return await new Promise(async function(resolve, reject) {
                setLocalidades(mockLocalidades);              
                resolve(mockLocalidades);                               
            });        
        }
        
        if(localidadesUnsubscribe){
            localidadesUnsubscribe();
            console.info("getLocalidades: Unsubscribe listner de localidades");
        }

        if(instancia){
            const queryEleicoes = query(collection(db, "/instancias/"+instancia+"/localidades"),orderBy("nmUe","asc"));
            localidadesUnsubscribe = onSnapshot(queryEleicoes, (querySnapshot) => {
                if(!querySnapshot.empty){                    
                    const list = [];
                    querySnapshot.forEach((doc) => {                
                        list.push(doc.data());
                    });                            
                    setLocalidades(list);
                }else{
                    console.error("getLocalidades: nenhuma localidade encontrada")                
                }
            },(error) => {
                throw error;
            });
        }
     
    }catch(error){
        if(localidadesUnsubscribe){
            localidadesUnsubscribe();
        }
        console.error("getLocalidade: "+error);
        throw error;    
    }
}

export const getCargos = async (mock,instancia,setCargos) => {
    try{
        if (mock && mockCargos){        
            return await new Promise(async function(resolve, reject) {
                setCargos(mockCargos);              
                resolve(mockCargos);                               
            });        
        }

        if(cargosUnsubscribe){
            cargosUnsubscribe();
            console.info("getCargos: Unsubscribe listner de cargos");
        }

        if(instancia){            
            const queryCargos = query(collection(db, "/instancias/"+instancia+"/cargos"));                                    
            cargosUnsubscribe = onSnapshot(queryCargos, (querySnapshot) => {
                if(!querySnapshot.empty){                    
                    const list = [];
                    querySnapshot.forEach((doc) => {                
                        list.push(doc.data());
                    });                            
                    setCargos(list);
                }else{
                    console.error("getCargos: nenhum cargo encontrado")                
                }
            },(error) => {
                throw error;
            });           
        }

    }catch(error){
        if(cargosUnsubscribe){
            cargosUnsubscribe();
        }    
        console.error("getCargos: "+error);
        throw error;   
    }
    
}


export const getZonasEleitorais = async (mock,instancia,setZonasEleitorais) => {
    try{
        if (mock && mockZonas){        
            return await new Promise(async function(resolve, reject) {
                setZonasEleitorais(mockZonas);              
                resolve(mockZonas);                               
            });        
        }

        if(zonasEleitoraisUnsubscribe){
            zonasEleitoraisUnsubscribe();
            console.info("getZonasEleitorais: Unsubscribe listner de zonas");
        }

        if(instancia){            
            const queryZonas = query(collection(db, "/instancias/"+instancia+"/zonas-eleitorais"),orderBy("nrZona","asc"));                                    
            zonasEleitoraisUnsubscribe = onSnapshot(queryZonas, (querySnapshot) => {
                if(!querySnapshot.empty){                    
                    const list = [];
                    querySnapshot.forEach((doc) => {                
                        list.push(doc.data());
                    });                            
                    setZonasEleitorais(list);
                }else{
                    console.error("getZonasEleitorais: nenhuma zona eleitoral encontrada")                
                }
            },(error) => {
                throw error;
            });
        }
      
    }catch(error){    
        if(zonasEleitoraisUnsubscribe){
            zonasEleitoraisUnsubscribe();
        }
        console.error("getZonasEleitorais: "+error);
        throw error;
    }
}

export const getLocaisVotacao = async (mock,instancia,setLocaisVotacao) => {
    try{         
        if (mock && mockLocaisVotacao){        
            return await new Promise(async function(resolve, reject) {
                setLocaisVotacao(mockLocaisVotacao);              
                resolve(mockLocaisVotacao);                               
            });        
        }

        if(locaisVotacaoUnsubscribe){
            locaisVotacaoUnsubscribe();
            console.info("getLocaisVotacao: Unsubscribe listner de locais de votação");
        }

        if(instancia){            
            const queryLocaisVotacao = query(collection(db, "/instancias/"+instancia+"/locais-votacao"),orderBy("nmLocal","asc"));;                                    
            locaisVotacaoUnsubscribe = onSnapshot(queryLocaisVotacao, (querySnapshot) => {
                if(!querySnapshot.empty){                    
                    const list = [];
                    querySnapshot.forEach((doc) => {                
                        list.push(doc.data());
                    });
                    setLocaisVotacao(list);
                }else{
                    console.error("getLocaisVotacao: nenhum local de votação encontrado")                
                }
            },(error) => {
                throw error;
            });
        }
       
    }catch(error){
        if(locaisVotacaoUnsubscribe){
            locaisVotacaoUnsubscribe();
        }    
        console.error("getLocaisVotacao: "+error);
        throw error;
    }
}

export const getFotoCandidatoByte64 = async (mock,instancia,codigoCandidato) => {
    try{
        if (mock){
            let userimg = {
                data: "data:/jpeg;base64,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",
                idCandidato:codigoCandidato,
                original:""
            }
            return await new Promise(async function(resolve, reject) {
                resolve(userimg);
            });
        }

        if(instancia){             
            //Obtem foto de um candidato
            const docSnap = await getDoc(doc(db, "/instancias/"+instancia+"/fotos/", codigoCandidato));            
            if (docSnap.exists()){                       
                return docSnap.data();
            }
            throw new Error("getFotoCandidatoByte64: Não foi possível carregar a foto do candidato ("+codigoCandidato+")");
        }
       
    }catch(error){    
        throw error;
    }
}

export const getTotalizacao = async (mock,instancia,codigoLocalidadeSelecionada,codigoCargoSelecionado,setTotalizacao) => {
    try{
        if (mock && mockTotalizacao){             
            return await new Promise(async function(resolve, reject) {
                setTotalizacao(mockTotalizacao);            
                resolve(mockTotalizacao);                               
            });        
        }

        if(totalizacaoUnsubscribe){
            totalizacaoUnsubscribe();
            console.info("getTotalizacao: Unsubscribe listner de totalização");
        }
        
        if(instancia){ 
            const queryTotalizacoes = query(collection(db, "/instancias/"+instancia+"/totalizacoes"),
                where("localidade.sgUe", "==", codigoLocalidadeSelecionada),
                where("cargo.codigo", "==", codigoCargoSelecionado),
                orderBy("dataHora", "desc"),
                limit(1));

             totalizacaoUnsubscribe = onSnapshot(queryTotalizacoes, (querySnapshot) => {
                let data = null;
                if(!querySnapshot.empty){                                        
                    querySnapshot.forEach((doc) => {
                        data = doc.data();
                    });                   
                }else{
                    console.error("getTotalizacao: totalização não encontrada")                
                }
                setTotalizacao(data);  
            },(error) => {
                throw error;
            });          
            
        }
      
    }catch(error){    
        if(totalizacaoUnsubscribe){
            totalizacaoUnsubscribe();
        }
        console.error("getTotalizacao: "+error);
        throw error;         
    }
}

export const getAcompanhamentoSecoes = async (mock,instancia,zonasEleitorais,setAcompanhamentoSecoes) => {
    try{
        if (mock && mockAcompanhamentoSecoes){
            return await new Promise(async function(resolve, reject) {
                let data= mockAcompanhamentoSecoes;  
                //processa as seções não lidas que não estão no documento do firestore para otimizar a mensagem
                data?.zonas?.forEach( zona =>{
                    let ze = zonasEleitorais?.find(ze => ze?.nrZona == zona?.nrZona);                        
                    zona['secoesNaoLidas']=ze?.secoes?.filter( secao => !zona?.secoesLidas.includes(secao));
                }) 
                setAcompanhamentoSecoes(data);              
                resolve(data);
            });        
        }

        if(acompanhamentoSecoesUnsubscribe){
            acompanhamentoSecoesUnsubscribe();
            console.info("getAcompanhamentoSecoes: Unsubscribe listner de Acompanhamento de Seçoes");
        }

        if(instancia){ 
            const queryAcompanhamnetoSecoes = query(collection(db, "/instancias/"+instancia+"/acompanhamento-secoes"),                
                orderBy("dataHora", "desc"),
                limit(1));
                                          
            acompanhamentoSecoesUnsubscribe= onSnapshot(queryAcompanhamnetoSecoes, (querySnapshot) => {
                let data=null;                
                if(!querySnapshot.empty){                                                    
                    querySnapshot.forEach((doc) => {                                      
                        data=doc.data();
                    });
                    //processa as seções não lidas que não estão no documento do firestore para otimizar a mensagem
                    data?.zonas?.forEach( zona =>{
                        let ze = zonasEleitorais?.find(zel => zel?.nrZona == zona?.nrZona);
                        zona['secoesNaoLidas']=ze?.secoes?.filter( secao => !zona?.secoesLidas.includes(Number(secao)));
                    })                    
                }else{
                    console.error("getAcompanhamentoSecoes: lista de acompanhamento não encontrada")                
                }    
                setAcompanhamentoSecoes(data);
                
            },(error) => {
                throw error;
            });
            
        }
      
    }catch(error){
        if(acompanhamentoSecoesUnsubscribe){
            acompanhamentoSecoesUnsubscribe();
        }
        console.error("getAcompanhamentoSecoes: "+error);
        throw error;
    }
}

export const getPendentes = async (mock, instancia, setPendentes, setUser) => {
    try{
        if (mock){
            return await new Promise(async function(resolve, reject) {                
                setPendentes([]);              
                resolve([]);
            });        
        }

        if(pendentesUnsubscribe){
            pendentesUnsubscribe();
            console.info("getPendentes: Unsubscribe listner de Acompanhamento de Seçoes Pendentes");
        }

        if(instancia){ 
            const queryPendentes = query(collection(db, "/instancias/"+instancia+"/bus-pendentes"),                
                orderBy("dataHora", "desc"));
                                            
            pendentesUnsubscribe= onSnapshot(queryPendentes, (querySnapshot) => {
                if(!querySnapshot.empty){                    
                    const list = [];
                    querySnapshot.forEach((doc) => {                
                        list.push(doc.data());
                    });
                    setPendentes(list);
                }else{
                    console.error("getPendentes: lista de pendencias não encontrada")                
                }                
            },(error) => {
                setUser()
                throw error;
            });                     
        }
      
    }catch(error){
        setUser()
        if(pendentesUnsubscribe){
            pendentesUnsubscribe();
        }
        console.error("getPendentes: "+error);
        throw error;
    }
}

export const setTotalizacaoPadrao = async (instancia) =>{    
    await addDoc(collection(db, "/instancias/"+instancia+"/totalizacoes/"), mockTotalizacao);
}

export const setAcompanhamentoSecoes = async (instancia, localidades, zonasEleitorais, locaisVotacao) =>{
    await addDoc(collection(db, "/instancias/"+instancia+"/acompanhamento-secoes/"), mockAcompanhamentoSecoes);  
}
